/* eslint-disable react/prop-types */
import React from "react";
import { Box, Tooltip, Typography, makeStyles } from "@material-ui/core";
import { FaFunnelDollar } from "react-icons/fa";
import {
  GiPayMoney,
  GiMoneyStack,
  GiCardboardBox,
  GiShoppingCart,
} from "react-icons/gi";
import { RiExchangeDollarFill } from "react-icons/ri";
import { IoIosPricetags } from "react-icons/io";
import { BsArrowUp } from "react-icons/bs";
import { useSelector } from "react-redux";
import _ from "lodash";
import { nFormatter } from "lib/utils";
import {
  SellOut,
  SellIn,
  SalesOut,
  SalesIn,
  InvestmentIn,
  InvestmentOut,
  UnitsIn,
  PriceOut,
  roi,
} from "resources/constants";

const useStyles = makeStyles((theme) => ({
  totalsItemValue: {
    display: "flex",
    alignItems: "center",
    marginLeft: "10px",
    color: "#4e4e4e",
  },
  containerRow: {
    alignItems: "center",
    fontSize: "12px",
  },
  withOutLeftMargin: {
    marginLeft: "0px",
  },
  totalsItemValueContainer: {
    display: "flex",
  },
  totalsItemContainer: {
    flex: "1 0 auto",
  },
  totalsItem: {
    padding: "5px",
    display: "flex",
    flexDirection: "column",
  },
  totalsItemWithLine: {
    paddingTop: "13px",
    paddingBottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  withLeftMargin: {
    // [theme.breakpoints.up("xs")]: {
    //   marginLeft: "5px",
    // },
    // [theme.breakpoints.up("sm")]: {
    //   marginLeft: "20px",
    // },
  },
  leftMarginLine: {
    marginLeft: "8px",
  },
  itemUnitsContainer: {
    display: "flex",
    flexDirection: "row",
  },
  justifyBetweenFlex: {
    display: "flex",
    justifyContent: "space-between",
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  totalItemPercentage: {
    display: "flex",
    flexDirection: "row",
    padding: "0px 10px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  arrowPercentage: {
    color: "#939393",
    marginRight: "1px",
  },
  percentageColor: {
    color: "#a2a2a2",
    fontSize: "13px",
  },
  rowLayout: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    alignItems: "center",
    // [theme.breakpoints.up("xs")]: {
    //   justifyContent: "space-between",
    //   flexGrow: 1,
    // },
    // [theme.breakpoints.up("sm")]: {
    //   justifyContent: "flex-end",
    // },
  },
  totalItemUnits: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  totalItemAbsolute: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  lineStyleLabel: {
    width: "4px",
    height: "21px",
    backgroundColor: "white",
    alignSelf: "flex-start",
    borderTopRightRadius: 2,
    borderTopLeftRadius: 2,
  },
  lineStyleValue: {
    width: "4px",
    height: "21px",
    backgroundColor: "white",
    alignSelf: "flex-start",
    borderBottomRightRadius: 2,
    borderBottomLeftRadius: 2,
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
  },
  unitsLineColor: {
    backgroundColor: "#47B5DB",
  },
  marginLineColor: {
    backgroundColor: "#66AE91",
  },
  standardLineColor: {
    backgroundColor: "white",
  },
}));

export default function ScenarioTotalsCardComponent({
  cardData,
  row,
  isReference,
  metadata,
  visibleKeys,
  showLabels,
  showInChart,
  showIcons = true,
  showLine = false,
  orderWithVisibleKeys = false,
  showPercentages = true,
}) {
  const classes = useStyles();
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const sellOutLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? SellOut
    : "Sell Out";
  const sellInLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? SellIn
    : "Sell In";
  const salesOutLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? SalesOut
    : "Sales Out";
  const salesInLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? SalesIn
    : "Sales In";
  const investmentInLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? InvestmentIn
    : "Investment In";
  const investmentOutLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? InvestmentOut
    : "Investment Out";
  const unitsInLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? UnitsIn
    : "Units In";
  const priceOutLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? PriceOut
    : "Price Out";
  const roiLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? roi
    : "ROI";

  const isPricing = window.location.pathname.includes("pricing");

  const cardDataWithOrder = {};
  if (orderWithVisibleKeys) {
    _.map(visibleKeys, (key) => {
      _.map(cardData, (v, k) => {
        if (key === k) cardDataWithOrder[key] = v;
      });
    });
  }

  const getTotalIcon = (key) => {
    switch (key) {
      case "margin":
        return <FaFunnelDollar size={20} />;
      case "sales":
        return <GiMoneyStack size={22} />;
      case "units":
        return <GiShoppingCart size={22} />;
      case "units_in":
        return <GiCardboardBox size={22} />;
      case "investment_in":
        return <GiPayMoney size={22} />;
      case "investment":
        return isPricing ? undefined : <GiPayMoney size={22} />;
      case "sales_in":
        return <GiMoneyStack size={22} />;
      case "price":
        return <IoIosPricetags size={22} />;
      case "roi":
        return <RiExchangeDollarFill size={23} />;
      default:
        return null;
    }
  };

  const getTotalLabel = (key) => {
    switch (key) {
      case "margin":
        return "Margin";
      case "sales":
        return salesOutLabelByTenant;
      case "units":
        return sellOutLabelByTenant;
      case "units_in":
        return unitsInLabelByTenant;
      case "investment":
        return isPricing ? undefined : "Investment";
      case "investment_in":
        return investmentInLabelByTenant;
      case "sales_in":
        return salesInLabelByTenant;
      case "price":
        return priceOutLabelByTenant;
      case "roi":
        return roiLabelByTenant;
      default:
        return null;
    }
  };

  const getTotalTooltip = (label) => {
    switch (label) {
      case "Sales-Out":
        return salesOutLabelByTenant;
      case "Sales-In":
        return salesInLabelByTenant;
      case "Investment-Out":
        return investmentOutLabelByTenant;
      case "Investment-In":
        return investmentInLabelByTenant;
      case "Margin":
        return "Margin";
      case "ROI":
        return "ROI";
      case "Sell-Out":
        return sellOutLabelByTenant;
      case "Sell-In":
        return sellInLabelByTenant;
      case "Price-Out":
        return priceOutLabelByTenant;
      default:
        return null;
    }
  };

  const pricingInvestmen = (key, cardValue) => {
    return isPricing && key === "investment" ? null : (
      <div
        className={`${classes.itemUnitsContainer} ${showLine &&
          classes.leftMarginLine}`}
      >
        <Typography
          variant="body2"
          style={{
            marginRight: "3px",
          }}
          className={`${classes.totalItemUnits}`}
        >
          <i>{metadata.all[key][0].unit}</i>
        </Typography>
        <Typography variant="body2" className={`${classes.totalItemAbsolute}`}>
          {cardValue.absolute !== undefined && cardValue.absolute !== null
            ? nFormatter(cardValue.absolute)
            : nFormatter(cardValue)}
        </Typography>
      </div>
    );
  };

  return (
    <Box
      component="div"
      className={`${row && classes.rowLayout}`}
      style={{ width: "auto" }}
    >
      {_.map(
        orderWithVisibleKeys ? cardDataWithOrder : cardData,
        (value, key) => {
          if (!visibleKeys.includes(key)) {
            return null;
          }

          if (!metadata.all[key] || metadata.all[key][0].visibility_type !== 2)
            return null;

          let cardValue = value;

          const lineColor =
            key === "units"
              ? classes.unitsLineColor
              : classes.standardLineColor;
          const lineCheckColor =
            key === "margin" ? classes.marginLineColor : lineColor;

          if (
            isReference &&
            (key === "investment_in" || key === "roi" || key === "investment")
          )
            cardValue = {
              absolute: 0,
              percentage: 0,
            };
          return cardValue.absolute !== null &&
            cardValue.absolute !== undefined ? (
            <Tooltip
              title={getTotalTooltip(metadata.all[key][0].label)}
              key={key}
              placement={row ? "top-start" : "left"}
              className={classes.totalsItemContainer}
            >
              <Box
                component="span"
                className={`${
                  showLine ? classes.totalsItemWithLine : classes.totalsItem
                } ${showLabels && showLine ? "" : classes.withLeftMargin}`}
                style={{ width: "auto" }}
              >
                {showLabels && (
                  <div className={showLine && classes.rowContainer}>
                    {showLine && (
                      <div
                        className={`${classes.lineStyleLabel} ${showLine &&
                          lineCheckColor}`}
                      />
                    )}
                    <Typography
                      variant="body2"
                      style={{
                        fontSize: showIcons ? "12px" : "15px",
                      }}
                      className={`${classes.totalItemUnits} ${showLine &&
                        classes.leftMarginLine}`}
                    >
                      {getTotalLabel(key)}
                    </Typography>
                  </div>
                )}
                <Box
                  content="span"
                  className={classes.totalsItemValueContainer}
                  style={{ width: "auto" }}
                >
                  {!showIcons ? null : getTotalIcon(key)}
                  {showLine && (
                    <div
                      className={`${classes.lineStyleValue} ${showLine &&
                        lineCheckColor}`}
                    />
                  )}
                  <Box
                    content="span"
                    style={{ width: "100%" }}
                    className={classes.justifyBetweenFlex}
                  >
                    {key === "margin" ||
                    key === "sales" ||
                    key === "sales_in" ||
                    key === "investment" ||
                    key === "investment_in" ||
                    key === "price" ? (
                      pricingInvestmen(key, cardValue)
                    ) : (
                      <div
                        className={`${classes.itemUnitsContainer} ${showLine &&
                          classes.leftMarginLine}`}
                        style={{ width: "auto", display: "flex" }}
                      >
                        <Typography
                          variant="body2"
                          className={`${classes.totalItemAbsolute}`}
                        >
                          {cardValue.absolute !== undefined &&
                          cardValue.absolute !== null
                            ? nFormatter(cardValue.absolute)
                            : nFormatter(cardValue)}
                        </Typography>

                        <Typography
                          variant="body2"
                          style={{
                            marginLeft: "4px",
                            whiteSpace: "nowrap",
                          }}
                          className={`${classes.totalItemUnits}`}
                        >
                          <i>{metadata.all[key][0].unit}</i>
                        </Typography>
                      </div>
                    )}
                    {cardValue.percentage !== 0 &&
                      showPercentages &&
                      !isReference &&
                      Math.abs(cardValue.percentage)
                        .toFixed(2)
                        .toString() !== "0.00" && (
                        <Box
                          component="span"
                          className={`${classes.totalItemPercentage} ${classes.percentageColor} `}
                        >
                          <BsArrowUp
                            size={showInChart ? 16 : 20}
                            strokeWidth={1.5}
                            style={{
                              marginRight: "3px",
                              color: `${
                                cardValue.percentage > 0 ? "#5AB793" : "#FD6464"
                              }`,
                              transform: `rotateX(${
                                cardValue.percentage > 0 ? "0deg" : "180deg"
                              }
                            )`,
                            }}
                          />
                          {Math.abs(cardValue.percentage).toFixed(2)}%
                        </Box>
                      )}
                  </Box>
                </Box>
              </Box>
            </Tooltip>
          ) : null;
        }
      )}
    </Box>
  );
}
